import { get, post } from 'utils/methods';

export function getRollsInApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_PP}rolls-in`, data, headers);
}

export function changeRollInStatusApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_PP}commands/roll-in/status`, data, headers);
}
